
const getDefaultState = () => ({
    pageName: 'default',
    pageClasses: [],
    modalName: null,
    goalOptions: [
        { value: 'cross', label: 'Cross training' },
        { value: 'distance', label: 'Distance running' },
        { value: 'trail', label: 'Trail running' },
    ],
    goalNames: {
        cross: 'cross training',
        distance: 'distance running',
        trail: 'trail running',
    },
    trainerOptions: [
        { value: 'izaic', speciality: 'cross' },
        { value: 'marta', speciality: 'cross' },
        { value: 'des', speciality: 'distance' },
        { value: 'cj', speciality: 'distance' },
        { value: 'mario', speciality: 'trail' },
        { value: 'camelia', speciality: 'trail' },
    ],
    anchorPoints: {
        membership: '.membership-anchor',
    },
});

const state = getDefaultState();

const getters = {
};

const { body } = document;
const LOADING_CLASS = 'page-loading';

const mutations = {
    pageEnter (state, newPage) {
        if (state.pageClasses && state.pageClasses.length) {
            body.classList.remove(...state.pageClasses);
        }

        state.pageName = newPage.pageName || newPage.$options.name;
        state.pageClasses = newPage.pageClasses;

        body.id = state.pageName;

        if (body.classList.contains(LOADING_CLASS)) {
            body.classList.remove(LOADING_CLASS);
        }
        if (state.pageClasses && state.pageClasses.length) {
            body.classList.add(...state.pageClasses);
        }
    },
    pageLeave (state) {
        body.classList.add(LOADING_CLASS);
    },

    modalOpen (state, newModal) {
        state.modalName = newModal.modalName;
    },
    modalClose (state) {
        state.modalName = null;
    },
};

const actions = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
